import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VarietyWiseNutrientList from "../components/VarientWiseNutrientList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Varient Wise Nutrient " />

        {/* UsersListLayer */}
        <VarietyWiseNutrientList />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
